import { Injectable, Injector } from '@angular/core';
import { GroupQuestion } from '../models/group-question';
import { HttpDataService } from '../../../core/services/http-data.service';
import { lastValueFrom } from 'rxjs';

@Injectable()
export class TutorizationQuestionService extends HttpDataService {
  public list: GroupQuestion[];

  constructor(protected injector: Injector) {
    super(injector, '/customizations/mars/questions');
  }

  getQuestion(id: string): Promise<any> {
    const url = `${this.baseUrl}/${id}`;
    return lastValueFrom(this.http.get(url, this.getRequestOptions()))
      .then((response) => response)
      .catch((error) => this.handlePromiseError(error));
  }
  getQuestionData(id: string) {
    const url = `${this.baseUrl}/${id}`;
    return lastValueFrom(this.http.get(url, this.getRequestOptions()))
      .then((response) => response)
      .catch((error) => this.handlePromiseError(error));
  }
  cancelQuestion(id: string) {
    const url = `${this.baseUrl}/${id}`;
    return this.putRequest(url, { status: 'CANCELLED' }, this.getRequestOptions());
  }

  publishQuestion(id: string) {
    const url = `${this.baseUrl}/${id}`;
    return this.putRequest(url, { status: 'PUBLISHED' }, this.getRequestOptions());
  }

  certifyQuestion(id: string) {
    const url = `${this.baseUrl}/${id}`;
    return this.putRequest(url, { status: 'CERTIFIED' }, this.getRequestOptions());
  }
}
